<div class="forecastcontainer">
   <div class="forecastSetting">
    <div class="topSection">
      <h3>Forecast settings</h3>
      <div class="checkboxColums">
        <div class="forecastBase">
          <h4>Forecast Base</h4>
          <div class="checkBox">
            <label for="inspections">Last 3 inspections</label>
            <mat-checkbox [checked]="Last3Inspection"></mat-checkbox>
          </div>
          <div class="checkBox">
            <label for="fleet">Fleet Average</label>
            <mat-checkbox [checked]="FleetAverage"></mat-checkbox>
          </div>
          <div class="scenario">
            <div class="title">
              <h4>Scenario</h4>
            </div>
            <div class="checkbuttons">
              <div class="checkBox">
                <label for="scenarioA">A</label>
                <mat-checkbox [checked]="scenarioA" id="scenarioA"></mat-checkbox>
              </div>
              <div class="checkBox">
                <label for="scenarioB">B</label>
                <mat-checkbox [checked]="scenarioB" id="scenarioB"></mat-checkbox>
              </div>
              <div class="checkBox">
                <label for="scenarioC">C</label>
                <mat-checkbox [checked]="scenarioC" id="scenarioC"></mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="forecast">
          <div class="title">
            <h4>Forecast</h4>
          </div>
          <div class="usage">
            <h4>Usage</h4>
            <div class="input">
              
                <input matInput type="number"  [(ngModel)]="lastThreeInspectionUsage"
                ngDefaultControl>
            
            </div>
            <div class="input">
              
                <input matInput type="number"   [(ngModel)]="scenarioUsageA"
                ngDefaultControl>
            
            </div>
            <div class="input">
              
                <input matInput type="text"   [(ngModel)]="scenarioUsageB"
                ngDefaultControl>
            
            </div>
            <div class="input">
              
                <input matInput type="text"  [(ngModel)]="scenarioUsageC"
                ngDefaultControl>
            
            </div>
          </div>
          <div class="distance">
            <h4>distance</h4>
            <div class="input">
              
                <input matInput type="text"  [(ngModel)]="lastThreeInspectionDistance"
                ngDefaultControl>
            
              <i class="fa-solid fa-pen"></i>
            </div>
            <div class="input">
              
                <input matInput type="text"  [(ngModel)]="scenarioDistanceA"
                ngDefaultControl>
            
              <i class="fa-solid fa-pen"></i>
            </div>
            <div class="input">
              
                <input matInput type="text"  [(ngModel)]="scenarioDistanceB"
                ngDefaultControl>
            
              <i class="fa-solid fa-pen"></i>
            </div>
            <div class="input">
              
                <input matInput type="text"  [(ngModel)]="scenarioDistanceC"
                ngDefaultControl>
            
              <i class="fa-solid fa-pen"></i>
            </div>
          </div>
        </div>
        <div class="safetyFactory">
          <div class="title">
            <h4>Forecast Safety Factor</h4>
          </div>
          <div class="rateFactor">
            
              <span class="label">Rate Factor</span>
              <input matInput type="number"  [(ngModel)]="rateFactor"
              ngDefaultControl>
          
            <i class="fa-solid fa-pen"></i>
          </div>
        </div>
        <div class="forecastMethod">
          <div class="title">
            <h4>Forecast method</h4>
          </div>
          <div class="checkBox">
            <label for="cmu">CMU</label>
                <mat-checkbox [checked]="cmu" id="cmu"></mat-checkbox>
          </div>
          <div class="checkBox">
            <label for="distance">Distance</label>
            <mat-checkbox [checked]="distance" id="distance"></mat-checkbox>
          </div>
        </div>
        <div class="updatetoActual">
          <div class="title">
            <h4>Update to Actual</h4>
          </div>
          <div class="inputBox">
            <div class="inputtext">
              <label for="Wenco">Wenco</label>
            </div>
            <div class="inputtext">
              <label for="upHours">Up Hours</label>
              <input matInput type="number"  [(ngModel)]="upHours" ngDefaultControl>
            </div>
            <div class="inputtext">
              <label for="downHours">Down Hours</label>
              <input matInput type="number"  [(ngModel)]="downHours" ngDefaultControl>
            </div>
            <div class="inputtext">
              <label for="currentSMU">Current SMU</label>
              <input matInput type="number"  [(ngModel)]="currentSMU" ngDefaultControl>
            </div>
            <div class="inputtext">
              <label for="dist">Dist</label>
              <input matInput type="number"  [(ngModel)]="dist" ngDefaultControl>
            </div>
          </div>
        </div>
      </div>
      <div class="buttonBox">
        <button type="button" class="btn-reset">Rest</button>
        <button type="button" class="btn-save">Save/Update</button>
        <i class="fa-solid fa-check"></i>
      </div>
    </div>
    <div class="bottomSection">
      <h3>Forecast Future Service Dates</h3>

      <div class="data">
        <div class="inspectionsDate">
          <h3>Last Inspection Date</h3>
          <p>27 Mar 2022</p>
          <p>SMU - 17500</p>
          <p>Distance - 15,200</p>
        </div>
        <div class="sercviceDate">
          <h3>Next Service Date</h3>
          <input matInput [matDatepicker]="nextServiceDatePicker"  [(ngModel)]="nextServiceDate" (dateChange)="NextServiceDateChange($event)"
              ngDefaultControl>
              <mat-datepicker-toggle matSuffix [for]="nextServiceDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #nextServiceDatePicker></mat-datepicker>
        </div>
        <div class="lastInspection">
          <h3>From Last Inspection</h3>
          <table>
            <tr>
              <td>Days</td>
              <td>Hours</td>
              <td>Dist</td>
            </tr>
            <tr>
              <td>109</td>
              <td>1795</td>
              <td>540</td>
            </tr>
          </table>
        </div>
        <div class="sercviceDate">
          <h3>Following Service Date</h3>
          <input matInput [matDatepicker]="followingServiceDatePicker"  [(ngModel)]="followingServiceDate" (dateChange)="FollowingDateChange($event)"
              ngDefaultControl>
              <mat-datepicker-toggle matSuffix [for]="followingServiceDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #followingServiceDatePicker></mat-datepicker>
        </div>
        <div class="lastInspection">
          <h3>From Last Inspection</h3>
          <table>
            <tr>
              <td>Days</td>
              <td>Hours</td>
              <td>Dist</td>
            </tr>
            <tr>
              <td>109</td>
              <td>1795</td>
              <td>540</td>
            </tr>
          </table>
        </div>
        <div class="sercviceDate">
          <h3>Floating Date</h3>
          <input matInput [matDatepicker]="floatingServiceDatePicker"  [(ngModel)]="floatingServiceDate" (dateChange)="FloatingDateChange($event)"
              ngDefaultControl>
              <mat-datepicker-toggle matSuffix [for]="floatingServiceDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #floatingServiceDatePicker></mat-datepicker>
        </div>
        <div class="lastInspection">
          <h3>From Last Inspection</h3>
          <table>
            <tr>
              <td>Days</td>
              <td>Hours</td>
              <td>Dist</td>
            </tr>
            <tr>
              <td>109</td>
              <td>1795</td>
              <td>540</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="buttonBox">
        <button type="button" class="btn-reset">Rest</button>
        <button type="button" class="btn-save">Save/Update</button>
        <i class="fa-solid fa-check"></i>
      </div>
    </div>
  </div>
  <!-- <div class="displayColumns">
    <div class="checkboxContainer">
      <div class="leftSidde">
        <div class="checkBox">
          <label for="all"
            ><strong>Display Columns</strong> Select All</label
          >
          <input type="checkbox" name="" id="all" />
        </div>
        <div class="checkBox">
          <label for="Distance"> Distance</label>
          <input type="checkbox" name="" id="Distance" />
        </div>
        <div class="checkBox">
          <label for="CMU"> CMU</label>
          <input type="checkbox" name="" id="CMU" />
        </div>
        <div class="checkBox">
          <label for="fleet"> Fleet Ave CMU/% worn</label>
          <input type="checkbox" name="" id="fleet" />
        </div>
        <div class="checkBox">
          <label for="ave1"> Ave CMU/Hour</label>
          <input type="checkbox" name="" id="ave1" />
        </div>
        <div class="checkBox">
          <label for="ave2"> Ave Distance/Hour</label>
          <input type="checkbox" name="" id="ave2" />
        </div>
        <div class="checkBox">
          <label for="ave3"> Ave CMU/%Worn</label>
          <input type="checkbox" name="" id="ave3" />
        </div>
        <div class="checkBox">
          <label for="ave4"> Ave Distance/%Worn</label>
          <input type="checkbox" name="" id="ave4" />
        </div>
        <div class="checkBox">
          <label for="ave5"> Ave Distance/mm</label>
          <input type="checkbox" name="" id="ave4" />
        </div>
        <div class="checkBox">
          <label for="ave6"> Ave CMU/mm</label>
          <input type="checkbox" name="" id="ave6" />
        </div>
      </div>
      <div class="rightSide">
        <div class="checkBox">
          <label for="CMU2"> CMU</label>
          <input type="checkbox" name="" id="CMU2" />
        </div>
        <div class="checkBox">
          <label for="Distance2"> Distance</label>
          <input type="checkbox" name="" id="Distance2" />
        </div>
        <div class="checkBox">
          <label for="CMU3"> CMU/%Worn</label>
          <input type="checkbox" name="" id="CMU3" />
        </div>
        <div class="checkBox">
          <label for="distance3"> Distance/%Worn</label>
          <input type="checkbox" name="" id="distance3" />
        </div>
        <div class="checkBox">
          <label for="dixtance4"> Distance/mm</label>
          <input type="checkbox" name="" id="dixtance4" />
        </div>
        <div class="checkBox">
          <label for="cmu4"> CMU/mm</label>
          <input type="checkbox" name="" id="cmu4" />
        </div>
      </div> 
      
    </div>
    <div class="buttonBox">
      <button type="button" class="btn-reset">Refresh Screen</button>
    </div>
  </div> -->
</div>
<div class="forecastcontainer">
  <div class="refreshButton">
    <button class="btn-reset">
      <span><i class="fa-solid fa-rotate"></i></span> Refresh Calculation
    </button>
  </div>
  <div class="saveButton"></div>
</div>